import PlacingSlipPreviewCard from "./placing-slip-preview-card";
import { useExistingPlacingSlipPreviewUrl } from "./placing-slip-file-preview";

const resolvePendingFile = (slipData: any): File | null => {
    const candidate = slipData?.pendingFiles?.[0];
    return candidate instanceof File ? candidate : null;
};

type Props = {
    data: any;
    allValues?: any;
};

const PlacingSlipSummary = ({ data, allValues }: Props) => {
    const slipData = allValues?.placingSlip || data || {};
    const pendingFile = resolvePendingFile(slipData);
    const hasExisting = Boolean(slipData?.hasExisting);
    const offerId = allValues?.offerId || "";

    const { previewUrl, loading } = useExistingPlacingSlipPreviewUrl(
        offerId,
        Boolean(hasExisting && !pendingFile && offerId),
    );

    if (!hasExisting && !pendingFile) {
        return (
            <div className="rounded-lg border-2 border-dashed border-gray-300 p-3 dark:border-gray-600">
                <p className="text-sm text-gray-500">No placing slip uploaded</p>
            </div>
        );
    }

    return (
        <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
                Placing Slip
            </label>
            {pendingFile ? (
                <PlacingSlipPreviewCard
                    file={pendingFile}
                    name={pendingFile.name}
                    badge="Pending upload"
                />
            ) : (
                <PlacingSlipPreviewCard
                    previewUrl={previewUrl}
                    previewLoading={loading}
                    name="Placing Slip"
                    badge="Uploaded document"
                />
            )}
        </div>
    );
};

export default PlacingSlipSummary;
